import { Component } from 'react';
import { KEYs } from '../../constants';

export class HelpScout extends Component {
  static propTypes = {};
  static defaultProps = {};

  componentDidMount() {
    let e = window;
    let t = document;
    let n = window.Beacon;

    function a() {
      var e = t.getElementsByTagName('script')[0];
      var n = t.createElement('script');
      n.type = 'text/javascript';
      n.async = !0;
      n.src = 'https://beacon-v2.helpscout.net';
      e.parentNode.insertBefore(n, e);
    }

    if (
      ((e.Beacon = n = function(t, n, a) {
        e.Beacon.readyQueue.push({ method: t, options: n, data: a });
      }),
      (n.readyQueue = []),
      'complete' === t.readyState)
    ) {
      return a();
    }

    e.attachEvent ? e.attachEvent('onload', a) : e.addEventListener('load', a, !1);

    window.Beacon('init', KEYs.helpscountAppId);
  }

  render() {
    return null;
  }
}

// export function IntercomTrigger(props) {
//   let { fallbackEmail, showMessages, newMessage, children, ...otherProps } = props;

//   let clickHandler = function(event) {
//     if (!window.Intercom) {
//       return;
//     }
//     if (!window.Intercom.booted) {
//       return;
//     }

//     event.preventDefault();

//     if (newMessage !== undefined) {
//       window.Intercom('showNewMessage', newMessage);
//     } else if (showMessages) {
//       window.Intercom('showMessages');
//     } else {
//       window.Intercom('show');
//     }
//   };

//   return (
//     <a {...otherProps} href={`mailto:${fallbackEmail}`} onClick={clickHandler}>
//       {children}
//     </a>
//   );
// }
// IntercomTrigger.propTypes = {
//   fallbackEmail: PropTypes.string,
//   showMessages: PropTypes.bool,
//   newMessage: PropTypes.string,
// };
// IntercomTrigger.defaultProps = {
//   fallbackEmail: 'hello@nucleus.church',
//   showMessages: false,
//   newMessage: undefined,
// };

// export function setLauncherVisibility(visibile) {
//   if (!window.Intercom) {
//     return;
//   }

//   window.Intercom('update', { hide_default_launcher: !visibile });
// }



// WEBPACK FOOTER //
// ./src/components/Helpscout/Beacon.js